<template>
  <div>
    <div class="header">
      <div class="identity text weight-600">
        {{ item.firstname }} {{ item.lastname }}
      </div>
      <div class="close-icon">
        <v-icon
          large
          class="ml-3 close-icon material-icons-outlined"
          @click="close"
        >
          close
        </v-icon>
      </div>
    </div>

    <div class="detail-row">
      <div>
        <v-col cols="1">
          <v-icon large class="event-icon material-icons-outlined"
            >event</v-icon
          >
        </v-col>
        <v-col cols="11">
          <div class="pl-2">Date d'inscription : {{ item.created_at }}</div>
        </v-col>
      </div>

      <div>
        <v-icon large class="avatar-icon material-icons-outlined">
          account_circle
        </v-icon>
        <span>Client Opt-in</span>
      </div>
    </div>
    <v-tabs v-model="tabs" background-color="#8179fe" centered dark>
      <v-tab>Informations personnelles</v-tab>
      <v-tab>Visites</v-tab>
      <v-tab>Passages</v-tab>
    </v-tabs>
    <v-tabs-items class="tabs-item" v-model="tabs">
      <v-tab-item class="px-0 py-4 tab-item">aezae </v-tab-item>
      <v-tab-item class="px-0 py-4 tab-item">
        <div v-for="(val, index) in visitsInfo" :key="index">
          <v-card flat class="mt-3 py-3 item-card rounded-lg">
            <v-row class="py-1" justify="space-around">
              <v-col cols="4">
                <div class="text weight-600 passage-time"
                  >Visite du {{ val.date }}
                </div>
              </v-col>
              <v-col cols="4">
                <div class="text weight-600 hour-time  "
                  >Heure : {{ val.heure }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-tab-item>

      <v-tab-item class="px-0 py-4 tab-item">
        <div v-for="(val, index) in passageInfo" :key="index">
          <v-card flat class="mt-3 py-3 item-card rounded-lg">
            <v-row class="py-1" justify="space-around">
              <v-col cols="4">
                <div class="text weight-600 passage-time"
                  >Passage du {{ val.date }}
                </div>
              </v-col>
              <v-col cols="4">
                <div class="text weight-600 hour-time  "
                  >Heure : {{ val.heure }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-tab-item>
    </v-tabs-items>

    <v-divider class="mt-1 mb-1"></v-divider>

    <v-row class="mt-3 pl-7" justify="start">
      <div class="personalInfo">Informations personnelles</div>
    </v-row>

    <v-col>
      <v-row>
        <v-row class="px-7 pt-4">
          <TextInput
            outlined
            v-model="firstname"
            :placeholder="item.firstname"
            label="Prénom"
          />
          <TextInput
            outlined
            v-model="lastname"
            :placeholder="item.lastname"
            label="Nom"
          />
        </v-row>
      </v-row>

      <v-row class="px-1">
        <v-col cols="8">
          <TextInput
            outlined
            v-model="mailAddress"
            :placeholder="item.email"
            label="Adresse email"
          />
        </v-col>
        <v-col cols="4">
          <TextInput
            outlined
            v-model="phone"
            :placeholder="item.phone_number"
            label="Téléphone"
          />
        </v-col>
      </v-row>

      <v-row class="pl-4 pt-2 segment-subtitle">Segment</v-row>

      <v-row class="px-4">
        <v-col cols="4">
          <SwitchInput
            label="Afterwork"
            color="#ffc306"
            :model="switchModel.afterwork"
          />
          <SwitchInput
            label="Récompense fidélité"
            color="#ff6685"
            :model="switchModel.fidelityAward"
          />
        </v-col>
      </v-row>
      <div>
        <v-tabs v-model="tabs" background-color="#8179fe" centered dark>
          <v-tab>Visites</v-tab>
          <v-tab>Passages</v-tab>
        </v-tabs>
        <v-tabs-items class="tabs-item" v-model="tabs">
          <v-tab-item class="px-0 py-4 tab-item">
            <div v-for="(val, index) in visitsInfo" :key="index">
              <v-card flat class="mt-3 py-3 item-card rounded-lg">
                <v-row class="py-1" justify="space-around">
                  <v-col cols="4">
                    <div class="text weight-600 passage-time"
                      >Visite du {{ val.date }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text weight-600 hour-time  "
                      >Heure : {{ val.heure }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item class="px-0 py-4 tab-item">
            <div v-for="(val, index) in passageInfo" :key="index">
              <v-card flat class="mt-3 py-3 item-card rounded-lg">
                <v-row class="py-1" justify="space-around">
                  <v-col cols="4">
                    <div class="text weight-600 passage-time"
                      >Passage du {{ val.date }}
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text weight-600 hour-time  "
                      >Heure : {{ val.heure }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-col>
  </div>
</template>

<script type="text/javascript">
import TextInput from '@/components/input/textInput';
import BorderedCard from '@/components/cards/bordered-card.vue';
import SwitchInput from '@/components/input/switchInput';

export default {
  components: {
    TextInput,
    BorderedCard,
    SwitchInput,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      switchModel: {
        morning: false,
        diner: false,
        break: false,
        weekend: false,
        afterwork: false,
        fidelityAward: false,
      },
      drawer: false,
      firstname: null,
      lastname: null,
      mailAddress: null,
      phone: null,
      morning: false,
      diner: false,
      breakfast: false,
      weekend: false,
      afterwork: false,
      fidelityAward: false,
      tabs: null,
    };
  },

  watch: {
    openDrawer() {
      this.drawer = true;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  computed: {
    passageInfo() {
      return this.$store.state.userOverview.rightDrawer.frequency;
    },
    visitsInfo() {
      return this.$store.state.userOverview.rightDrawer.visits;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  .close-icon {
    position: absolute;
    top: -1rem;
    right: -1rem;
    background: whitesmoke;
    border-radius: 50px;
  }
}
.detail-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
/*
#drawer {
  width: 890px !important;
  margin-right: 31px;
  margin-top: 36px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  .v-navigation-drawer__content {
    height: calc(100vh - 60px);
  }
  .v-tabs-bar .v-tabs-bar__content > *:last-child {
    margin-right: 0px !important;
  }
  .v-tab--active {
    width: 50%;
    padding-left: 3% !important;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    color: black;
    margin-left: 0px !important;
    background-color: #8179fe;
    color: #ffffff !important;
  }
  .v-tab {
    color: black;
    margin-right: 20% !important;
  }
  .v-tab::hover {
    color: #ffffff !important;
  }
  .v-tabs-slider-wrapper {
    height: 4px !important;
    left: 0px !important;
    width: 100% !important;
    color: #8179fe !important;
  }
  .v-slide-group__content {
    background-color: #ffffff;
  }
  .close-icon {
    margin-top: -40px;
    color: $color-secondary;
  }
  .event-icon {
    color: $color-secondary;
  }
  .avatar-icon {
    color: $green-base;
  }
  .identity {
    font-size: 33px;
    letter-spacing: 0.33px;
    color: $color-secondary;
  }
  .personalInfo {
    color: $purple-drawer;
    font-size: 22px;
  }
  .segment-subtitle {
    color: $purple-drawer;
    font-size: 22px;
  }
  .passage-time {
    color: $color-primary;
  }
  .item-card {
    height: 58px;
    border: 1px solid #f1efff;
  }
  .tabs-item {
    height: 400px;
  }
  .tab-item {
    overflow: scroll;
    overflow-x: hidden;
  }
}*/
</style>
